import { inject, Injectable, Optional } from "@angular/core";
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpEventType,
    HttpInterceptor,
    HttpHandlerFn,
} from "@angular/common/http";
import { from, mergeMap, Observable } from "rxjs";

import { KeycloakService } from "./keycloak.service";

export function authInterceptorFn(
    req: HttpRequest<any>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
    const apiKey = config.API_KEY;
    const keycloakService = inject(KeycloakService);
    const token$ = from(keycloakService.getToken());
    return token$.pipe(
        mergeMap((token) => {
            const authReq = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                    KeyId: apiKey,
                },
            });
            return next(authReq);
        }),
    );
}
